import React from 'react';
import Button from "../../../../../components/Button";
import { useTranslation } from 'react-i18next';

interface ButtonsProps {
  tab: 'propertyDetails' | 'users';
  loading: boolean;
  actionTwoLoading?: boolean;
  view?: boolean;
  edit?: boolean;
  onSubmit: (action: '1' | '2', e?: React.FormEvent) => void;
  onCancel: () => void;
}

const Buttons: React.FC<ButtonsProps> = ({
  tab, loading, actionTwoLoading, view, edit, onSubmit, onCancel
}) => {
  const { t } = useTranslation();

  return (
    <div className="p-4">
      {
        !view && tab !== 'users' && (
          <>
            <Button
              text={t('property.addEdit.pageTexts.form.buttons.save')}
              disabled={loading || actionTwoLoading}
              loading={loading}
              className="btn btn-primary me-3"
              onClick={e => onSubmit('1', e)}
            />

            {
              !edit && (
                <Button
                  className="btn btn-primary me-3"
                  text={t("property.addEdit.pageTexts.form.buttons.saveAndCreateNew")}
                  disabled={loading || actionTwoLoading}
                  loading={actionTwoLoading}
                  onClick={(e) => onSubmit('2', e)}
                />
              )
            }
          </>
        )
      }
      <Button text={t('property.addEdit.pageTexts.form.buttons.cancel')} className="btn btn-outline-secondary" onClick={onCancel} />
    </div>
  );
};

export default Buttons;


